import { Chevron } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import messages from './HeatingComponent.messages';
import metadata from './HeatingComponent.metadata.json5';
import styles from '../Construction.module.scss';

function HeatingComponent(props) {
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const construction = _.get(submissionVM, 'lobData.homeowners_tfpa.coverables_Ext.construction');
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('Heating');
    const { refreshData } = useDataRefresh();
    const [showHeatingUpdate, updateHeatingUpdate] = useState(false);
    const [showGasSpaceHeader, updateShowGasSpaceHeater] = useState(false);
    const [showGasSpaceHeaderVented, updateShowGasSpaceHeaterVented] = useState(false);
    const [showHeatingDescription, updateShowHeatingDescription] = useState(false);
    const policyType = _.get(submissionVM, 'lobData.homeowners_tfpa.policyType_TWIA.value.code');

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'Heating');
    }, [findInvalidComponent, isComponentValid])

    const refreshFields = useCallback(() => {
        const heatingUpgradeExists = _.get(construction, 'heatingUpgradeExists.value') === true;
        const heatingType = _.get(construction, 'primaryHeatingType.value.code');
        const spaceHeater = heatingType === 'SpaceHeater_ext';
        const other = heatingType === 'Other';
        const gasSpaceHeater = _.get(construction, 'gasSpaceHeaterPriHeating_ext.value') === true;

        // 2024-08-19 - Debra Frum - DE16218 - Clear invisible Construction Heating fields
        if (!spaceHeater) {
            _.set(construction,`gasSpaceHeaterPriHeating_ext.value`, undefined );
            _.set(construction,`gasSpaceHeatVented_ext.value`, undefined );
        }
        if (!gasSpaceHeater) {
            _.set(construction,`gasSpaceHeatVented_ext.value`, undefined );
        }
        if (!heatingUpgradeExists) {
            _.set(construction,`heatingUpgradeYear.value`, undefined );
         }

        updateHeatingUpdate(heatingUpgradeExists);
        updateShowGasSpaceHeater(spaceHeater);
        updateShowGasSpaceHeaterVented(spaceHeater && gasSpaceHeater);
        updateShowHeatingDescription(other);
        updateWizardData(submissionVM);
    });

    useEffect(() => {
        refreshFields();
    },[])

    const writeValue = useCallback(
        (value, path) => {
            refreshFields();
            refreshData();
        }, [refreshData, submissionVM, updateWizardData]
    );

    const overrides = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true,
            readOnly: true
        },
        updateYear: {
            visible: showHeatingUpdate
        },
        gasSpaceHeater: {
            visible: showGasSpaceHeader
        },
        properlyVented: {
            visible: showGasSpaceHeaderVented
        },
        heatingDescription: {
            visible: showHeatingDescription
        },
        roofSpace: {
            visible: policyType !== 'HO6'
        },
        heatingUpgraded: {
            visible: policyType !== 'HO6'
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {}
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={construction}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

export default HeatingComponent;
